import type { $Fetch } from 'ofetch';
import type { TenantFeature, PerfilTenant } from '@/domain/model/TenantFeature';
import type {
  TenantFeatureGateway, ToggleFeatureCommand,
} from '@/application/port/out/TenantFeatureGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpTenantFeatureGateway implements TenantFeatureGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<TenantFeature[]> {
    const res = await this.client<ApiResponse<TenantFeature[]>>(
      '/api/v1/admin/tenant-features', { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async toggle(command: ToggleFeatureCommand): Promise<TenantFeature> {
    const res = await this.client<ApiResponse<TenantFeature>>(
      '/api/v1/admin/tenant-features',
      { method: 'PUT', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async applyProfile(perfil: PerfilTenant): Promise<void> {
    const res = await this.client<ApiResponse<null>>(
      '/api/v1/admin/tenant-features/apply-profile',
      { method: 'POST', body: { perfil } });
    assertApiSuccess(res);
  }
}
